import { render, staticRenderFns } from "./ServiceRequestDetails.vue?vue&type=template&id=4d64a252&scoped=true&"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestDetails.vue?vue&type=style&index=0&id=4d64a252&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64a252",
  null
  
)

export default component.exports